import React from 'react'

import { useState, useEffect,useContext } from "react";

// @mui material components 
import Api from '../../Classes/API/UsersApi';
// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import GetEmployeeTypesById from '../../Classes/Models/Requests/Administration/Employees/GetEmployeeTypesById';

// Material Dashboard 2 React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import { useParams } from 'react-router-dom';
import CreateTherapistEmployeeTypeReq from 'Classes/Models/Requests/Administration/Types/CreateTherapistEmployeeTypeReq';
import Swal from 'sweetalert2';
import TextField from '@mui/material/TextField';

import MDTypography from "components/MDTypography";
 
import { LanguageContext } from "App";
import Button from '@mui/material/Button';

import MDInput from 'components/MDInput';

import CardHeader from '@mui/material/CardHeader';
 
const EditemployeeTypeType = () => {
  const { id } = useParams()
  const {translations} = useContext(LanguageContext)
  const [EmployeeTypeName, SetEmployeeTypeName] = useState('test');
  const [EmployeeTypeHourlyRate, SetEmployeeTypeHourlyRate] = useState('');
  const [ErrorText, SetErrorText] = useState(false);
  const [IsLoaded, SetIsLoaded] = useState(false);

  let employeeModel = new GetEmployeeTypesById();
  useEffect(() => {
    employeeModel.searchInt = parseInt(id);

    Api.GetEmployeeTypeById(employeeModel).then((response) => {
      console.log(response);
      SetEmployeeTypeName(response.data.typeName)
      SetEmployeeTypeHourlyRate(response.data.standardHourlyRate)
    })
  }, ['default']);
  


  const GetData = async () => {
    employeeModel.searchInt = parseInt(id);
    var res = await Api.GetEmployeeTypeById(employeeModel);
    if(res.status == "Success"){
      SetEmployeeTypeName(res.data.typeName)
      SetEmployeeTypeHourlyRate(res.data.standardHourlyRate)
      SetIsLoaded(true)
    }
  }

  useEffect(async () => {
    if(!IsLoaded){ 
      await GetData() 
    }
  }, [IsLoaded])
  
  

  if(!IsLoaded){
    return(
      <div>
        LOADING...
      </div>
    )
  }


  let CreateTherapistEmployeeTypeReqModel = new CreateTherapistEmployeeTypeReq();

  const submitForm =  () => {

    if (!EmployeeTypeName || !EmployeeTypeHourlyRate) {
      SetErrorText(true);
      return;
    }


    

    CreateTherapistEmployeeTypeReqModel.Id = parseInt(id);
    CreateTherapistEmployeeTypeReqModel.TypeName = EmployeeTypeName;
    CreateTherapistEmployeeTypeReqModel.StandardHourlyRate = EmployeeTypeHourlyRate;

     Api.EditEmployeeType(CreateTherapistEmployeeTypeReqModel).then((response) => {
      if (response.status === "Success") {
        Swal.fire('Employee Updated', '', 'success');
      } else {
        Swal.fire('Error', '', 'error');
      }
    })
  }


  return (
    <div>
      <DashboardLayout>

        {/* Page Title */}
        <CardHeader className="mb-2" title={translations.EmployeeTypetableEditEmployeeType}></CardHeader>

        {/* Search form */}
        <div className="card mt-3">
          <div className="card-body">
            <CardHeader className="mb-2" title={translations.EmployeeTypeTitle}>
            </CardHeader>
            <div className="container-fluid">
              <div className="row">

                {/* Employee type name */}
                <div className="col-md-4">
                  <MDInput className="full-width" label={translations.EmployeeTypeEmployeetypename} defaultValue={EmployeeTypeName} onChange={(e) => SetEmployeeTypeName(e.target.value)}  />
                </div>
                 

                {/* standard Hourly Rate */}
                <div className="col-md-4">
                  <TextField className="full-width" label="Employee Type Hourly Rate" type="number" defaultValue={EmployeeTypeHourlyRate} onChange={(e) => SetEmployeeTypeHourlyRate(e.target.value)}  />
                </div>
              </div> 

              <div className="text-right mt-3 ">
                <Button className="white" variant="contained" size="medium" onClick={submitForm}>
                  {translations.EmployeeTypetableSave}
                </Button>
              </div>

              {!EmployeeTypeName &&
                ErrorText == true &&
                <small className="alert alert-danger font-sm mt-4 mx-0 text-right d-block" role="alert"> برجاء إدخال أسم المعالج </small>}

              {!EmployeeTypeHourlyRate &&
                ErrorText == true &&
                <small className="alert alert-danger font-sm mt-4 mx-0 text-right d-block" role="alert"> برجاء إدخال سعر ساعة المعالج </small>}

            </div>

          </div>
        </div>



      </DashboardLayout>
    </div>
  )
}

export default EditemployeeTypeType; 